import { render, staticRenderFns } from "./PaymentReceivedView.vue?vue&type=template&id=5578ced0&"
import script from "./PaymentReceivedView.vue?vue&type=script&lang=js&"
export * from "./PaymentReceivedView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReceivedView.vue?vue&type=style&index=0&id=5578ced0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports